import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import getServices from "../../Services/get-service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import swal from "sweetalert";
import { Checkbox, Menu, MenuItem } from "@mui/material";
import more from "../../Assets/images/more.svg";
import TopDCom from "./TopDCom";
import Constants from "../../Constant";

export default function InvestmentSubscribers() {
  const { investmentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [planName, setPlanName] = useState(location.state?.plan?.name || "");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [investmentStats, setInvestmentStats] = useState({
    totalAmountInvested: 0,
    totalUnits: 0,
    availableUnits: 0,
    soldUnits: 0,
    unitPrice: 0,
    investmentPoolName: "",
  });

  useEffect(() => {
    const fetchUsersAndStats = async () => {
      if (!investmentId) return;
      setLoading(true);

      try {
        const response = await getServices.getInvestmentPlanUsers(investmentId);
        if (response.data.status === "2000") {
          const data = response.data.data.userInvestments || [];
          setUsers(data);
          setFilteredUsers(data);
        } else {
          swal(response.data.description);
        }

        const statsResponse = await getServices.getInvestmentStats(
          investmentId
        );
        if (
          statsResponse?.data?.status === "2000" &&
          statsResponse.data?.data
        ) {
          const stats = statsResponse.data.data;
          setInvestmentStats({
            totalAmountInvested: stats.totalAmountInvested || 0,
            totalUnits: stats.totalUnits || 0,
            availableUnits: stats.availableUnits || 0,
            soldUnits: stats.soldUnits || 0,
            unitPrice: stats.unitPrice || 0,
            investmentPoolName: stats.investmentPoolName || "",
          });

          if (!planName && stats.investmentPoolName) {
            setPlanName(stats.investmentPoolName);
          }
        }
      } catch (error) {
        console.error("Error fetching subscribers or stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersAndStats();
  }, [investmentId]);

  useEffect(() => {
    let filtered = users;

    if (searchTerm) {
      filtered = filtered.filter((user) => {
        const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
        const email = user.email?.toLowerCase() || "";
        const search = searchTerm.toLowerCase();
        return fullName.includes(search) || email.includes(search);
      });
    }

    if (statusFilter) {
      filtered = filtered.filter((user) => user.status === statusFilter);
    }

    setFilteredUsers(filtered);
  }, [searchTerm, statusFilter, users]);

  const handleOpenMenu = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedUser(null);
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        {loading ? (
          <Skeleton height={30} width={300} />
        ) : (
          <h2 className="text-2xl font-semibold text-gray-800 capitalize">
            Users for {planName || `Investment ${investmentId}`}
          </h2>
        )}

        <button
          onClick={() => navigate(-1)}
          className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300"
        >
          Back
        </button>
      </div>

      <div className="my-8 flex flex-wrap items-center gap-4">
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-4">
          <div className="w-full sm:w-auto lg:col-span-3">
            <input
              placeholder="Search by name or email address"
              className="border border-gray-300 focus:border-primary-color outline-none p-2 rounded-lg w-full"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
          </div>

          <div>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="border border-gray-300 p-2 rounded-lg w-full lg:col-span-2"
            >
              <option value="">Status</option>
              <option value="ACTIVE">Active</option>
              <option value="PENDING">Pending</option>
              <option value="MATURED">Matured</option>
              <option value="WITHDRAWN">Withdrawn</option>
              <option value="CANCELLED">Cancelled</option>
              <option value="SUSPENDED">Suspended</option>
            </select>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-5 gap-4 mb-8">
        <TopDCom
          name="Total Amount Invested"
          count={investmentStats.totalAmountInvested || 0}
        />
        <TopDCom name="Total Units" count={investmentStats.totalUnits || 0} />
        <TopDCom
          name="Available Units"
          count={investmentStats.availableUnits || 0}
        />
        <TopDCom name="Sold Units" count={investmentStats.soldUnits || 0} />
        <TopDCom name="Unit Price" count={investmentStats.unitPrice || 0} />
      </div>

      {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 my-5">
        

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <p className="text-sm font-semibold text-gray-600">Active savings plan</p>
            <p className="text-sm font-semibold text-gray-900">
              {investmentStats.totalUnits ?? 0}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <p className="text-sm font-semibold text-gray-600">Available Units</p>
            <p className="text-sm font-semibold text-gray-900">
              {investmentStats.availableUnits ?? 0}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <p className="text-sm font-semibold text-gray-600">Sold Units</p>
            <p className="text-sm font-semibold text-gray-900">
              {investmentStats.soldUnits ?? 0}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <p className="text-sm font-semibold text-gray-600">Unit Price</p>
            <p className="text-sm font-semibold text-gray-900">
              NGN {Constants.FormatNumber(investmentStats.unitPrice ?? 0)}
            </p>
          </div>

          <div className="border-2 rounded-lg border-gray-200 p-3">
            <p className="text-sm font-semibold text-gray-600">Total Amount Invested</p>
            <p className="text-sm font-semibold text-gray-900">
              NGN {Constants.FormatNumber(investmentStats.totalAmountInvested?? 0)}
            </p>
          </div>
        </div> */}

      <div className="hidden md:flex flex-row justify-between items-center bg-primary-bg rounded-t-md rounded-r-md border-primary-border border p-4">
        <Checkbox />
        <p className="text-text flex-1 text-center">User</p>
        <p className="text-text flex-1 text-center">Email</p>
        <p className="text-text flex-1 text-center">Date Created</p>
        <p className="text-text flex-1 text-center">Maturity Date</p>
        <p className="text-text flex-1 text-center">Amount</p>
        <p className="text-text flex-1 text-center">Status</p>
        <p className="text-text flex-1 text-center">Action</p>
      </div>

      {loading ? (
        <div>
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white border-b border-gray-200 p-4 gap-2"
            >
              <div className="w-6 md:w-[5%]">
                <Skeleton width={24} height={24} />
              </div>
              {[...Array(6)].map((_, j) => (
                <div key={j} className="flex-1 text-left md:text-center">
                  <Skeleton width="70%" height={20} />
                </div>
              ))}
              <div className="flex-1 text-left md:text-center">
                <Skeleton width={24} height={24} className="mx-auto" />
              </div>
            </div>
          ))}
        </div>
      ) : filteredUsers.length === 0 ? (
        <div className="text-center text-gray-500 mt-10">
          {searchTerm || statusFilter
            ? "No subscribers match your search criteria."
            : "No subscribers found for this investment."}
        </div>
      ) : (
        <>
          <div className="md:hidden">
            {filteredUsers.map((user, index) => (
              <div
                key={index}
                className="border rounded-lg p-4 mb-3 bg-white shadow-sm"
              >
                <p className="font-semibold">
                  {user.firstName} {user.lastName}
                </p>
                <p>
                  <b>Email:</b> {user.email}
                </p>
                <p>
                  <b>Date Created:</b>{" "}
                  {user.createdAt?.split("T")?.[0] || "N/A"}
                </p>
                <p>
                  <b>Maturity Date:</b>{" "}
                  {user.maturityAt?.split("T")?.[0] || "N/A"}
                </p>
                <p>
                  <b>Amount:</b> ₦{user.amount.toLocaleString()}
                </p>
                <p>
                  <b>Status:</b>{" "}
                  <span
                    className={`font-medium ${
                      user.status === "ACTIVE"
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {user.status}
                  </span>
                </p>
                <div className="flex justify-end mt-2">
                  <img
                    src={more}
                    alt="More options"
                    className="cursor-pointer"
                    onClick={(e) => handleOpenMenu(e, user)}
                  />
                </div>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl) && selectedUser === user}
                  onClose={handleCloseMenu}
                >
                  <MenuItem>View Details</MenuItem>
                  <MenuItem sx={{ color: "#ef4444" }}>Disable</MenuItem>
                </Menu>
              </div>
            ))}
          </div>

          <div className="hidden md:block">
            {filteredUsers.map((user, index) => (
              <div
                key={index}
                className="flex flex-row justify-between items-center bg-white border-b border-gray-200 p-4"
              >
                <Checkbox />
                <p className="flex-1 text-center">
                  {user.firstName} {user.lastName}
                </p>
                <p className="flex-1 text-center">{user.email}</p>
                <p className="flex-1 text-center">
                  {user.createdAt?.split("T")?.[0] || "N/A"}
                </p>
                <p className="flex-1 text-center">
                  {user.maturityAt?.split("T")?.[0] || "N/A"}
                </p>
                <p className="flex-1 text-center">
                  ₦{user.amount.toLocaleString()}
                </p>
                <p
                  className={`flex-1 text-center font-medium ${
                    user.status === "ACTIVE" ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {user.status}
                </p>
                <div className="flex-1 text-center">
                  <img
                    src={more}
                    alt="More options"
                    className="mx-auto cursor-pointer"
                    onClick={(e) => handleOpenMenu(e, user)}
                  />
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && selectedUser === user}
                    onClose={handleCloseMenu}
                  >
                    <MenuItem>View Details</MenuItem>
                    <MenuItem sx={{ color: "#ef4444" }}>Disable</MenuItem>
                  </Menu>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {!loading && filteredUsers.length > 0 && (
        <div className="mt-4 text-sm text-gray-600">
          Showing {filteredUsers.length} of {users.length} subscriber
          {users.length !== 1 ? "s" : ""}
        </div>
      )}
    </div>
  );
}
